import { lazy } from "react";

export default lazy(() => import("./eager"));
export type { PdfViewerProps } from "./eager";
